import React from "react";
import { skills, tools } from "../../constants";

const Skills = () => {
  return (
    <section class="skills section" id="skills">
      <h2 class="section-title">Skills</h2>
      <div class="skills-container bd-grid">
        <div class="skills-box">
          <h3 class="skills-subtitle">
            Development <span class="purple">Skills</span>
          </h3>
          {skills.map((skill, index) => (
            <span class="skills-name" key={index}>
              <div class="skill-content">
                <i className={skill.className}></i>
                <a href="/">{skill.title}</a>
              </div>
            </span>
          ))}

          <h3 class="skills-subtitle">
            <span class="purple">Tools</span> I use
          </h3>

          {tools.map((tool, index) => (
            <span class="skills-name" key={index}>
              <div class="skill-content">
                <i className={tool.className}></i>
                <a href="/">{tool.title}</a>
              </div>
            </span>
          ))}
        </div>
        <div class="skill-img">
          <img src="about2.png" alt="" />
        </div>
      </div>
    </section>
  );
};

export default Skills;
